module.exports = __webpack_public_path__ + "static/media/31-2.5517a2be.mp3";